import { Box } from '@mui/material';
import { base64DocumentToURL } from 'app/helpers/fileHelper';
import React, { useEffect } from 'react';

type Props = {
  /** Raw base64 PDF bytes (no data: prefix); same contract as server PDF preview state. */
  document?: string;
  disablePointerEvents?: boolean;
};

/**
 * Placement candidate contract only: PDF `<object>` preview for client-generated PDF.
 * Duplicated from the PDF branch inside `PreviewScreen.tsx` so shared `PreviewScreen` stays unchanged.
 */
export const PlacementCandidateContractClientPdfPreview: React.FC<Props> = ({ document, disablePointerEvents }) => {
  const [data, setData] = React.useState<string | null>(null);

  useEffect(() => {
    if (document == null || document === '') {
      setData(null);
      return;
    }
    const { url, dispose } = base64DocumentToURL(document, {
      fileType: 'application/pdf',
    });
    setData(url);
    return () => {
      dispose();
    };
  }, [document]);

  if (!data) return null;

  return (
    <Box sx={{ width: '100%', height: 720, flexShrink: 0 }}>
      <object
        aria-label="placement-candidate-contract-client-pdf-preview"
        title="Contract PDF preview"
        data={`${data}#toolbar=0`}
        style={{
          width: '100%',
          height: '100%',
          minHeight: 400,
          border: 'none',
          pointerEvents: disablePointerEvents ? 'none' : undefined,
        }}
      />
    </Box>
  );
};
